import moment from 'moment';
import 'moment/locale/ru';

export const toLocaleDate = (date: string | undefined) => {
  const transformDateToUTC = moment.utc(date);
  return moment(transformDateToUTC).local().locale('ru');
};

export default toLocaleDate;